// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPublicStatementInfoDto
 */
export interface IPublicStatementInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPublicStatementInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPublicStatementInfoDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPublicStatementInfoDto
     */
    generation_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPublicStatementInfoDto
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicStatementInfoDto
     */
    statement_type?: IPublicStatementInfoDtoStatementTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPublicStatementInfoDtoStatementTypeEnum {
    BANKING_STATEMENT = 'BANKING_STATEMENT',
    INVESTMENT_STATEMENT = 'INVESTMENT_STATEMENT'
}


/**
 * Check if a given object implements the IPublicStatementInfoDto interface.
 */
export function instanceOfIPublicStatementInfoDto(value: object): value is IPublicStatementInfoDto {
    return true;
}

export function IPublicStatementInfoDtoFromJSON(json: any): IPublicStatementInfoDto {
    return IPublicStatementInfoDtoFromJSONTyped(json, false);
}

export function IPublicStatementInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPublicStatementInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'generation_date': json['generation_date'] == null ? undefined : (new Date(json['generation_date'])),
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'statement_type': json['statement_type'] == null ? undefined : json['statement_type'],
    };
}

export function IPublicStatementInfoDtoToJSON(json: any): IPublicStatementInfoDto {
    return IPublicStatementInfoDtoToJSONTyped(json, false);
}

export function IPublicStatementInfoDtoToJSONTyped(value?: IPublicStatementInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'generation_date': value['generation_date'] == null ? undefined : ((value['generation_date']).toISOString()),
        'file_url': value['file_url'],
        'statement_type': value['statement_type'],
    };
}

